export const GET_BID_STATUS_LIST = "GET_BID_STATUS_LIST";

export const BID_LIST_ACTION = "BID_LIST_ACTION";
